import React from 'react'
import PropTypes from 'prop-types'

import { TextField } from 'material-ui'
import CloseIcon from '../../assets/CloseIcon'

import classNames from 'classnames/bind'
import styles from '../styles/MessageTemplateEditor.css'

const cx = classNames.bind(styles)

const templateModalHeader = cx('templateModalHeader')
const templateModalTitle = cx('templateModalTitle')
const templateNameRow = cx('templateNameRow')
const closeButton = cx('closeButton')

const MessageTemplateEditorHeader = ({
  closeCreateTemplateModal,
  isEmail,
  templateName,
  templateNameUpdate,
}) => {
  return (
    <div className={templateModalHeader}>
      <div className={closeButton} onClick={closeCreateTemplateModal}>
        <CloseIcon />
      </div>
      <div className={templateModalTitle}>{`${
        isEmail ? 'Email' : 'Text'
      } Message Template`}</div>
      <div className={templateNameRow}>
        <div style={{ marginRight: '10px' }}>Template Name: </div>
        <TextField
          id="TemplateName"
          hintText="Add template name"
          onChange={e => templateNameUpdate(e)}
          value={templateName || ''}
          style={{
            width: '170px',
            height: '40px',
          }}
          hintStyle={{
            bottom: '7px',
            color: 'rgba(0, 0, 0, 0.55)',
            fontStyle: 'Italic',
            fontSize: '13px',
          }}
        />
      </div>
    </div>
  )
}

MessageTemplateEditorHeader.propTypes = {
  closeCreateTemplateModal: PropTypes.func.isRequired,
  templateName: PropTypes.string,
  templateNameUpdate: PropTypes.func.isRequired,
}

export default MessageTemplateEditorHeader



// WEBPACK FOOTER //
// ./src/components/Messages/MessageTemplateEditor/MessageTemplateEditorHeader.js